export function hasContent(text) {
  if (!text) {
    return false;
  }
  if (text.trim() === '') {
    return false;
  }
  if (text.replace(/<\/?p>/g, '').replace(/<br\s*\/?>/g, '').trim() === '') {
    return false;
  }
  return true;
}